export const isDev = () =>
  !!(process && process.env && process.env.ENVIRONMENT === 'development');
export const isProd = () =>
  !(process && process.env && process.env.ENVIRONMENT === 'development');

export const institution = () => process.env.INSTITUTION;
